import { render, staticRenderFns } from "./ConfigurarDemo.vue?vue&type=template&id=21dc9408&"
import script from "./ConfigurarDemo.vue?vue&type=script&lang=js&"
export * from "./ConfigurarDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports